// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__9OanZ","modalFooterButton":"ModalNotes_modalFooterButton__3y-Qo"};